<template>
  <div class="import-export-manager">
    <b-row>
      <b-col lg="6">
        <b-card>
          <b-card-header>
            <h6 class="mb-0">
              <feather-icon icon="UploadIcon" size="16" class="mr-1"/>
              Import Questions
            </h6>
          </b-card-header>
          <div class="text-center p-4">
            <feather-icon icon="UploadIcon" size="48" class="text-muted mb-3"/>
            <h6 class="text-muted">Import Questions from File</h6>
            <p class="text-muted">Support for JSON and CSV formats</p>
            <b-button variant="primary" disabled>
              <feather-icon icon="UploadIcon" size="16" class="mr-1"/>
              Coming Soon
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card>
          <b-card-header>
            <h6 class="mb-0">
              <feather-icon icon="DownloadIcon" size="16" class="mr-1"/>
              Export Questions
            </h6>
          </b-card-header>
          <div class="text-center p-4">
            <feather-icon icon="DownloadIcon" size="48" class="text-muted mb-3"/>
            <h6 class="text-muted">Export Test Pack Questions</h6>
            <p class="text-muted">Download questions in various formats</p>
            <b-button variant="outline-primary" disabled>
              <feather-icon icon="DownloadIcon" size="16" class="mr-1"/>
              Coming Soon
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BCardHeader, BButton } from 'bootstrap-vue'

export default {
  name: 'ImportExportManager',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BButton
  },
  props: {
    testPacks: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.import-export-manager {
  .card {
    border: none;
    box-shadow: 0 4px 25px 0 rgba(0,0,0,0.1);
  }

  .card-header {
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;

    h6 {
      color: #2c2c2c;
      font-weight: 600;
    }
  }
}
</style>